<!--
 * @Author: jiaxiuc
 * @Date: 2024-03-21 15:04:32
 * @LastEditors: jiaxiuc
 * @LastEditTime: 2024-04-02
-->
<template>
  <div class="comp-xl-source-condition">
    <jw-space direction="vertical">
      <template v-for="(sub, index) in paramsList" :key="index">
        <jw-space style="margin-bottom: 20px">
          <jw-space class="field-name" direction="vertical">
            <jw-select v-model="sub.field" class="right-content" :placeholder="$t('请选择')" :style="{ width: '330px' }" @change="changeChild($event, index)" allow-search>
              <jw-option v-for="item in columns" :key="item.fieldKey" :value="item.fieldKey">{{ item.fieldName }}</jw-option>
            </jw-select>
            <label v-show="sub.field">
              <div style="display: flex; align-items: center; color: var(--color-text-3); font-size: 12px">
                <span> {{ $t('参数名') }}：</span>
                <jw-typography-paragraph copyable style="margin-bottom: 0"> {{ sub.parameters }} </jw-typography-paragraph>
              </div>
            </label>
          </jw-space>
          <jw-select class="right-content" v-model="sub.type" :placeholder="$t('请选择')" :style="{ width: '330px' }" allow-search @change="changeChildTwo($event)">
            <jw-option v-for="item in sub.field ? conditions[columns[sub.field]?.fieldType] : []" :key="item.value" :value="item?.value">{{ item?.label }}</jw-option>
          </jw-select>
          <icon-minus-circle @click="conditionUpdate(ritem, index)" class="del-item" :size="20" />
        </jw-space>
      </template>
      <jw-button type="outline" @click="conditionUpdate()" style="margin-top: -20px">
        <template #icon>
          <icon-plus />
        </template>
        {{ $t('新建参数') }}
      </jw-button>
    </jw-space>
  </div>
</template>

<script setup>
import { reactive, ref, watch, toValue, nextTick } from 'vue';
import { tools } from '@/utils/tools';
import _ from 'lodash';
const props = defineProps({
  fieldlist: {
    type: Array,
    default: () => []
  },
  list: {
    type: Array,
    default: () => []
  }
});
const emits = defineEmits(['validate']);
const columns = ref([]);
watch(
  () => props.fieldlist,
  (list) => {
    columns.value = _.omitBy(list, (item) => {
      return item.fieldType === 18 || item.fieldType === 9;
    });
  },
  {
    immediate: true,
    deep: true
  }
);
watch(
  () => props.list,
  (list) => {
    //2025年03月18日20:33:25zl将setTimeout100修改为nextTick
    nextTick(() => {
      initSourceData(list);
    });
  },
  {
    immediate: true,
    deep: true
  }
);
import { contractFieldTypeObj } from '@/utils/const';
const conditions = reactive({
  0: [0, 1],
  1: [1],
  2: [0, 1, 2],
  3: [0, 1, 3],
  4: [0, 1, 2],
  5: [0, 1, 3],
  6: [0, 1, 6],
  7: [0, 1, 7],
  8: [8],
  9: [],
  10: [0, 1, 2],
  11: [0, 1],
  12: [0, 1, 2, 3], //查找关联（单选)(多选)
  16: [0, 1, 7, 16],
  18: [],
  21: [], //引用字段
  22: [0, 1],
  24: [], //计算字段
  23: [0, 1, 7],
  13: [0, 1]
});
for (const key in conditions) {
  conditions[key] = conditions[key].map((field) => {
    return {
      label: contractFieldTypeObj[field],
      value: field
    };
  });
}

const paramsList = ref([]);
const initSourceData = (list) => {
  paramsList.value = list.map((param) => {
    const fieldObj = {
      id: param.id,
      type: param.type,
      field: param.fieldKey,
      parameters: param.parameters,
      fieldId: param.fieldId,
      fieldName: param.fieldName
    };
    return fieldObj;
  });
};
const conditionUpdate = (data, index) => {
  console.log(data, index);
  if (!index && index != 0) {
    paramsList.value.push({ type: '', field: '', parameters: tools.randomString(), fieldName: '' });
  } else {
    paramsList.value.splice(index, 1);
    emits('validate', paramsList.value);
  }
};
const changeChild = async (e, index) => {
  paramsList.value[index].type = '';
  const fieldobj = columns.value[e];
  paramsList.value[index].fieldId = fieldobj.id;
  paramsList.value[index].fieldKey = fieldobj.fieldKey;
  paramsList.value[index].fieldName = fieldobj.fieldName;
  emits('validate', paramsList.value);
};
const getData = () => {
  return JSON.parse(JSON.stringify(toValue(paramsList)));
};
defineExpose({
  getData
});
const changeChildTwo = async () => {
  emits('validate', paramsList.value);
};
</script>
<style scoped lang="less">
@import './xl-source-condition.less';
</style>
